import Vue from 'vue';
import Axios from 'axios';
import store from './../../store';
// import ToastMessages from './../../lang/en/messages/toast.json';
// import EventBus from './../../event-bus';
import AuthService from './../auth';

// When the request succeeds
const success = (response) => {
  localStorage.setItem('token', response.token);
  Axios.defaults.headers.common.Authorization = `Bearer ${response.token}`;
  store.dispatch('auth/refresh', { refreshDate: new Date() }).then(() => {
    // AuthService.Check();
  });
};

// When the request fails
const failed = (error) => {
  /*EventBus.AlertEvent.showAlert({
    title: 'Session Expired',
    message: ToastMessages.logout.successfulFailure,
  });*/
  store.dispatch('auth/logout', error.data).then(() => {
    /*
    Vue.router.push({
      name: 'login',
    });
    */
  });
};

export default () => {
  if (localStorage.getItem('token') !== null) {
    Axios.put('/auth').then((response) => {
      success(response.data);
    }).catch((error) => {
      failed(error);
    });
  }
};
